import { EEnvironment, FEATURE_FLAG_RELEASE_PRODUCTION, IEnvironment } from '@redngapps/shared/env/types';

export const environment: IEnvironment = {
  name: EEnvironment.production,
  urls: {},
  featureSwitches: {
    angularProdModeEnabled: true,
    apm: false,
    devTools: false,
    sentry: false,
    // Env release of the runtime-toggleable flags — same shared source the client env uses, so the
    // overview's `envEnabled` reflects this instance's release without duplicating the values.
    ...FEATURE_FLAG_RELEASE_PRODUCTION,
  },
  softwareVersion: '1.0.0',
  gitHash: 'will-be-replaced',
};
